// BeeNexa Hive — design tokens (JS mirror of hive.css variables).
// Use these when a value is needed in JS (e.g. inline gradients on AppIcon).
// The canonical source for CSS is hive.css; keep the two in sync.

export const HIVE_COLORS = {
  bg: '#0d2119',
  bgDeep: '#091810',
  surface: '#14301f',
  surface2: '#1c4531',
  surface3: '#245239',
  primary: '#355942',
  primarySoft: '#95bcb8',
  gold: '#e3b23c',
  goldBright: '#f2c94c',
  text: '#f4f7f2',
  textDim: '#9db3a6',
  line: 'rgba(255,255,255,0.08)',
};

// Per-category tile gradients. `key` matches category ids in categories.js and
// the `accent` field on registry apps. Two-stop 135deg gradients read as glossy
// app-icon tiles against the dark canvas.
export const CATEGORY_GRADIENTS = {
  business: ['#2f7d4f', '#1f5a37'],
  restaurant: ['#f0a13a', '#d9791f'],
  booking: ['#2bb4c8', '#1a8598'],
  realEstate: ['#8a63d2', '#6636b0'],
  gameRooms: ['#f2c94c', '#d99a1f'],
  finance: ['#34c07a', '#1e8a55'],
  event: ['#ef6a8f', '#c73a67'],
  personal: ['#5b8def', '#3560c9'],
  system: ['#5f7a6b', '#3d5346'],
};

// Resolve a two-stop CSS gradient string for a given accent/category key.
export const gradientFor = (key) => {
  const stops = CATEGORY_GRADIENTS[key] || CATEGORY_GRADIENTS.system;
  return `linear-gradient(135deg, ${stops[0]}, ${stops[1]})`;
};

export const HIVE_HONEY = 'linear-gradient(135deg, #f2c94c, #e3a72c)';
